import { styledThemed } from "../../../../../utils/styledThemed";

export const Card = styledThemed.div`
  width: 250px;
  padding: 20px 15px;
  border-radius: 4px;
  background-color: #1f242e;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 15px;
  @media screen and (min-width: ${(props) => props.theme.medium}) {
    width: 250px;
  }
  @media screen and (min-width: ${(props) => props.theme.large}) {
    width: 280px;
  }
`;
